import PersonWorkHistory from "./PersonWorkHistory";

export default PersonWorkHistory;
